/*
 *  Copyright 2024 LiteFarm.org
 *  This file is part of LiteFarm.
 *
 *  LiteFarm is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  LiteFarm is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 *  GNU General Public License for more details, see <https://www.gnu.org/licenses/>.
 */

export enum ANIMAL_ID_PREFIX {
  DEFAULT = 'default',
  CUSTOM = 'custom',
}

export enum AnimalOrBatchKeys {
  ANIMAL = 'ANIMAL',
  BATCH = 'BATCH',
}

export enum AnimalSexes {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum AnimalOrigins {
  BROUGHT_IN = 'BROUGHT_IN',
  BORN_AT_FARM = 'BORN_AT_FARM',
}
